import { JwtAxios } from '@/packaging';
export const zigzagApi = {
  async GetZigzagApiTemplate(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetZigzagApiTemplate?marketAccount=${marketAccount}`
    );
    return responseModel;
  },
  async SetZigzagApiTemplate(model) {
    const responseModel = await JwtAxios.post(`/Template/Market/SetZigzagApiTemplate`, model);
    return responseModel;
  },
  async SetZigzagApi(body) {
    const responseModel = await JwtAxios.post('/Template/Market/SetZigzagApi', body);
    return responseModel;
  },
  async GetZigzagTemplateOptions(marketAccount) {
    const responseModel = await JwtAxios.get(
      `/Template/Market/GetZigzagTemplateOptions?marketAccount=${marketAccount}`
    );
    return responseModel;
  }
};
